import { graphql, useStaticQuery } from 'gatsby'

const useArticleListQuery = () => {
  const data = useStaticQuery(graphql`
    {
      articleList: allContentfulArticle(
        sort: { fields: publishDate, order: DESC }
      ) {
        nodes {
          ...ArticleCardFragment
        }
      }
    }
  `)

  return data.articleList
}

export default useArticleListQuery
